
import Dummy from "components/Dummy";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import QuillViewer from "components/inputs/richEditor/QuillViewer";
import InputNumber from "components/inputs/signUp/InputNumber";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { AuthContext } from "providers/AuthProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import { decode } from "shared/utils/Utils";

function ProductDetail() {
    const location = useLocation();
    const [product, setProduct] = useState();
    const dispatch = useDispatch();
    const { id, productId } = useParams();
    const navigate = useNavigate();
    const { userName } = useContext(AuthContext);


    const quantityRef = useRef();
    useEffect(() => {
        if (location) {
            setProduct(location.state.data);
        }
    }, [location])

    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none"
    }
    const onAddCartClick = () => {
        if (userName) {
            if (quantityRef.current.getValue() > 0) {
                dispatch(CartReducer.actions.addProductToCart({ ...product, quantity: quantityRef.current.getValue() }));
                toast.success(`장바구니에 추가되었습니다.`, {
                    autoClose: 1000,
                    position: toast.POSITION.BOTTOM_CENTER
                });
            } else {
                toast.error(`장바구니 수량을 선택해주세요.`, {
                    autoClose: 1000,
                    position: toast.POSITION.BOTTOM_CENTER
                });
            }
        } else {
            toast.error(`로그인하세요.`, {
                autoClose: 1000,
                position: toast.POSITION.BOTTOM_CENTER
            });
        }




    }
    const orderClick = () => {
        if (userName) {
            if (quantityRef.current.getValue() > 0) {
                navigate(`/ws/${id}/homepage/orderSummary/${productId}`, { state: { product: product, quantity: quantityRef.current.getValue() } }, { replace: true });
            } else {
                toast.error(`수량을 선택해주세요.`, {
                    autoClose: 1000,
                    position: toast.POSITION.BOTTOM_CENTER
                });
            }
        } else {
            toast.error(`로그인하세요.`, {
                autoClose: 1000,
                position: toast.POSITION.BOTTOM_CENTER
            });
        }


    }


    return (
        <Container maxWidth={1200}>
            <Dummy height={"30px"} />
            <VerticalFlex gap={15}>
                <FlexChild>
                    <HorizontalFlex>
                        <FlexChild width={"30%"}>
                            {/* <div style={{border: "1px solid black"}}> */}
                            <img src={product && product.productImg} width={"100%"} />
                            {/* </div> */}
                        </FlexChild>
                        <FlexChild>
                            <VerticalFlex flexStart gap={15}>
                                <FlexChild>
                                    <Center width={"100%"} textAlign={"left"}>
                                        <P weight={"bold"} size={"min(3.2vw, 30px)"}>{product && product.productName}</P>
                                        <P weight={"bold"} size={"min(2.8vw, 25px)"}>\ {product ? product.price.toLocaleString() : 0}</P>
                                    </Center>
                                </FlexChild>
                                <FlexChild width={"40%"}>
                                    <InputNumber ref={quantityRef} />
                                </FlexChild>
                                <FlexChild>
                                    <HorizontalFlex gap={20}>
                                        <FlexChild width={"max-content"}>
                                            <CustomButton text={"구매하기"} style={btnStyle} onClick={orderClick} />
                                        </FlexChild>
                                        <FlexChild>
                                            <CustomButton text={"장바구니"} onClick={onAddCartClick} />
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                            </VerticalFlex>

                        </FlexChild>

                    </HorizontalFlex>
                </FlexChild>
                <FlexChild height={"1px"} backgroundColor={"black"} />
                <FlexChild>
                    {

                        product && product.productDetailImg.startsWith("PHA")
                            ?
                            <div style={{ maxWidth: "1200px", height: '100%', overflowY: 'visible' }}>
                                <QuillViewer value={decode(product && product.productDetailImg)} />
                            </div>
                            :
                            <img src={product && product.productDetailImg} width={"100%"} />
                    }
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
}

export default ProductDetail;